import React from "react";
import { Helmet } from "react-helmet";

const WebsiteTitle = ({ title }) => {
  return (
    <Helmet>
      <title>{title?.length ? "Amuse | " + title : "Amuse The Kids"}</title>
    </Helmet>
  );
};

export default WebsiteTitle;
